(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/play-page.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/play-page.js');

'use strict';

const {
  useEffect,
  useState
} = React;
const {
  Ticker,
  TickerText,
  Betslip,
  MapPlay,
  LocationInput,
  LocationButtons,
  CenterMapButton,
  PlayPageContainer,
  Params,
  SearchOverlay
} = svs.lyckoplatsen.components.page_play.react.components;
const {
  useStorageWager
} = svs.lyckoplatsen.page_play.utils;
const {
  mapErrorDialog
} = svs.lyckoplatsen.shared_map.utils;
const jwt = svs.lyckoplatsen.data.config.jwt;
const PlayPage = () => {
  useStorageWager();
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 300);
    if (typeof jwt !== 'string' || jwt.length === 0) {
      mapErrorDialog();
    }
    return () => clearTimeout(timer);
  }, []);
  return React.createElement(PlayPageContainer, null, React.createElement(Params, null), React.createElement("div", {
    className: "lp-play-map-container relative ".concat(isLoaded ? 'page-loaded' : '')
  }, React.createElement("div", {
    className: "lp-location-container"
  }, React.createElement("div", {
    className: "animated-body"
  }, React.createElement(LocationInput, null), React.createElement(LocationButtons, null))), React.createElement(MapPlay, null), React.createElement(CenterMapButton, null), React.createElement(Ticker, null), React.createElement(TickerText, null), React.createElement(Betslip, null)), React.createElement(SearchOverlay, null));
};
setGlobal('svs.lyckoplatsen.components.page_play.react', {
  PlayPage
});

 })(window);